<template>
  <div class="content-skeleton" :class="`content-skeleton--${variant}`" role="status" aria-live="polite"
    :aria-label="label" aria-busy="true">
    <div v-for="item in count" :key="item" class="skeleton-item" aria-hidden="true">
      <span class="skeleton-block skeleton-icon"></span>
      <div class="skeleton-copy">
        <span class="skeleton-block skeleton-title"></span>
        <span class="skeleton-block skeleton-line"></span>
        <span class="skeleton-block skeleton-short"></span>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  variant: { type: String, default: 'cards', validator: value => ['cards', 'list'].includes(value) },
  count: { type: Number, default: 4 },
  label: { type: String, default: 'Loading content…' },
})
</script>

<style scoped>
.content-skeleton { display: grid; gap: 16px; padding: 16px 0; width: 100%; }
.content-skeleton--cards { grid-template-columns: repeat(auto-fit, minmax(min(100%, 220px), 1fr)); }
.skeleton-item { display: flex; gap: 16px; padding: 20px; border: 1px solid rgba(127, 139, 149, 0.14); border-radius: 16px; background: var(--ps-surface-raised, #fff); overflow: hidden; }
.content-skeleton--cards .skeleton-item { flex-direction: column; min-height: 180px; }
.skeleton-copy { display: flex; flex: 1; flex-direction: column; gap: 12px; min-width: 0; }
.skeleton-block { display: block; background: linear-gradient(100deg, #edf0f2 25%, #f8fafb 45%, #edf0f2 65%); background-size: 250% 100%; animation: skeleton-shimmer 1.8s ease-in-out infinite; border-radius: 6px; }
.skeleton-icon { width: 40px; height: 40px; flex-shrink: 0; border-radius: 12px; }
.skeleton-title { width: 64%; height: 16px; margin-bottom: 4px; }
.skeleton-line { width: 92%; height: 10px; }
.skeleton-short { width: 44%; height: 10px; }
@keyframes skeleton-shimmer { from { background-position: 100% 0; } to { background-position: -100% 0; } }
@media (prefers-reduced-motion: reduce) { .skeleton-block { animation: none; } }
</style>
